
  import * as HomeLogic from "./src/home-logic.js";
  window.HomeLogic = HomeLogic;
